export default __webpack_public_path__ + "static/media/charitable-donations.7fc1987f.svg";